import axios from 'axios';

import Decimal from 'app/src/data/base/Decimal';
import { InvoicingPayload } from 'root/apps/QuoteMachineIntegration/state/InvoicingPayload';
import { datadogRum } from 'root/datadog/datadogRum';

export default class PaymentService {
  static async makePayment(payload: InvoicingPayload, creditLimit: Decimal) {
    try {
      const { data } = await axios.post(
        `admin/invoicing/make-payment?credit_limit=${creditLimit}`,
        payload
      );
      return data;
    } catch (error) {
      datadogRum.addError(error, {
        message: `Failed to post admin/invoicing/make-payment`,
      });
      throw error;
    }
  }
}
